<template>
  <div class="dashboard-section">
    <div class="dashboard-section-header">
      <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Rechercher un employeur</div>
      <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
    </div>
    <div class="dashboard-section-content">
      <div class="dashboard-section-content-italic">
        Vous êtes près du but ! Pour vous aider dans vos recherches, voici quelques conseils :
      </div>
      <div class="dashboard-section-content-steps">
        <div class="dashboard-section-content-steps-row">
          <div><img class="raster" src="@/assets/img/plus.png"></div>
          <div>Actualisez votre dossier de candidature (photo, CV, etc) car celui-ci est visible des employeurs en recherche sur notre cvthèque.
            <em style="font-weight: normal" v-if="profilViewedCount === 1"><br/>(Votre profil a été consulté par <span style="font-weight: bolder">{{ profilViewedCount }}</span> employeur au cours des deux derniers mois)</em>
            <em style="font-weight: normal" v-if="profilViewedCount > 1"><br/>(Votre profil a été consulté par <span style="font-weight: bolder">{{ profilViewedCount }}</span> employeurs au cours des deux derniers mois)</em>
          </div>
        </div>
        <div class="dashboard-section-content-steps-row">
          <div><img class="raster" src="@/assets/img/plus.png"></div>
          <div>Consultez régulièrement notre page <a href="https://www.facebook.com/APForm" target="_blank"><u>Facebook</u></a> où de nombreuses offres d'emploi sont publiées.</div>
        </div>
        <div class="dashboard-section-content-steps-row">
          <div><img class="raster" src="@/assets/img/plus.png"></div>
          <div>Envoyez vos candidatures spontanées en personnalisant vos lettres de motivation aux cliniques vétérinaires qui vous intéressent.</div>
        </div>
      </div>
      <div class="dashboard-section-content-italic">
        La signature d'un contrat d'alternance avec employeur assure une place en formation (sous réserve de place disponible).
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "DashboardEmployerSearch",
  props: {
    profilViewedCount: Number
  }
};
</script>
